/* tslint:disable */
/* eslint-disable */
export enum DateTypes {
  Invoicedate = 'INVOICEDATE',
  Servicedate = 'SERVICEDATE',
}
